import { useEntityPanelManager } from './entity-panel-manager';
import { useWorkspaceStore } from '../../../use-workspace-store';
import { getEntityPanelSortComparator, getHistoricalPanelSortComparator } from '../utils';

export const useOpenAttachmentsPanels = (searchText: string) => {
    const entityPanelManager = useEntityPanelManager();
    const attachmentsPanels = entityPanelManager.attachmentsPanelsList;
    const workspacePanelsStore = useWorkspaceStore();

    const allAttachmentsWorkspacePanels = workspacePanelsStore.activePanels.filter(
        (panel) => panel.workspacePanelType === 'MEDIA_ATTACHMENTS'
    );

    const filteredAttachmentsPanels = attachmentsPanels
        .filter((attachmentsPanel) => {
            if (!searchText) return true;
            const formattedSearchText = searchText.trim().toLowerCase();
            const panelHash = [
                attachmentsPanel.entityId?.toString(),
                attachmentsPanel.entityType,
                attachmentsPanel.metadata?.entityNumber,
            ]
                .filter((x) => !!x)
                .join('~')
                .toLowerCase();
            return panelHash.indexOf(formattedSearchText) !== -1;
        })
        .sort(getEntityPanelSortComparator);

    const historicalAttachmentsPanels = entityPanelManager.historicalAttachmentsPanelsList;

    const filteredRecentAttachmentsPanels = historicalAttachmentsPanels
        .filter((historicalAttachmentsData) => {
            if (!searchText) return true;
            if (
                allAttachmentsWorkspacePanels.some(
                    (panel) => panel.linkedEntityId === historicalAttachmentsData.entityId
                )
            ) {
                return false;
            }
            const formattedSearchText = searchText.trim().toLowerCase();
            const panelHash = [
                historicalAttachmentsData.entityId?.toString(),
                historicalAttachmentsData.entityType,
                historicalAttachmentsData.entityNumber,
            ]
                .filter((x) => !!x)
                .join('~')
                .toLowerCase();
            return panelHash.indexOf(formattedSearchText) !== -1;
        })
        .sort(getHistoricalPanelSortComparator)
        .slice(0, 20);

    return {
        filteredAttachmentsPanels,
        filteredRecentAttachmentsPanels,
        allAttachmentsWorkspacePanels,
    };
};
